module.exports = __webpack_public_path__ + "static/multiframe-d54dc548abe045196e4dcb6a733a6e6a.png";